import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { Translate } from 'react-localize-redux'
import useStyles from './RemovePlayerAccessStyles'

// @todo: #transfer add translations
const DeactivatePlayerDialog = ({ open, onClose, onSubmit }) => {
  const classes = useStyles()

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Translate id="movePlayers.archive-player-in-team" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Translate id="movePlayers.are-you-sure-you-want-to-archive-this-player" />
        </DialogContentText>
        <List component="ul" disablePadding className={classes.orderedList}>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={
                <Typography color="textSecondary">
                  <Translate id="movePlayers.they-will-be-removed-from-future-team-activities" />
                </Typography>
              }
              primaryTypographyProps={{ style: { fontWeight: '600' } }}
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={
                <Typography color="textSecondary">
                  <Translate id="movePlayers.person-remains-active-at-club-level-and-can-be-reactivated" />
                </Typography>
              }
              primaryTypographyProps={{ style: { fontWeight: '600' } }}
            />
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          <Translate id="button.cancel" />
        </Button>
        <Button
          onClick={onSubmit}
          color="primary"
          variant="contained"
          autoFocus
        >
          <Translate id="button.archive" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DeactivatePlayerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default DeactivatePlayerDialog
